import z from "zod";

/**
 * CopyChecklistServicoSchema
 */

export const CopyChecklistServicoSchema = z.object({
  codigo: z.string().nonempty('Este campo deve ser preenchido!'),
  nroRevisao: z.string().nonempty('Este campo deve ser preenchido!'),
  descricao: z.string().nonempty('Este campo deve ser preenchido!'),
});

/**
 * CopyChecklistServicoForm
 */

export type CopyChecklistServicoForm = z.infer<typeof CopyChecklistServicoSchema>;